import type {ReactElement} from 'react';
import React from 'react';
import {useSingleActivePosterItem} from '@Hooks/poster-editor/useSingleActivePosterItem';
import {BaseVideoMediaControls} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-video-media-controls';
import type {ItemData} from '@PosterWhiteboard/page/add-item.class';
import {onReplaceMedia} from '@PosterWhiteboard/page/replace-item.class';

export function VideoMediaControls(): ReactElement<any> {
  const activeItem = useSingleActivePosterItem();

  if (!activeItem) {
    throw new Error('Active item does not exist in video media controls');
  }

  if (!activeItem.isVideo()) {
    throw new Error(`Expected active item to be of type video item, instead got ${activeItem.gitype}`);
  }

  const onUnMute = (): void => {
    activeItem.toggleMuteUnmuteState();
  };

  const onReplaceVideo = (itemToReplaceWith: ItemData): void => {
    onReplaceMedia(itemToReplaceWith);
  };

  return <BaseVideoMediaControls activeItem={activeItem} onReplaceVideo={onReplaceVideo} onUnMute={onUnMute} />;
}
